import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/About.css';

const About = () => {
  const timelineData = [
    { 
      role: 'Software & AI Automation Engineer', 
      company: 'Prodcycle', 
      date: 'SEPT 2025 - PRESENT', 
      desc: 'Driving technical excellence and intelligent automation within the production lifecycle, implementing AI-driven workflows and scalable software solutions.' 
    },
    { 
      role: 'Full-Stack Engineer & AI Automation Specialist', 
      company: 'Independent / Freelance', 
      date: '2026 - PRESENT', 
      desc: 'Architecting high-performance digital ecosystems using Deepgram AI, LiveKit, and Go. Specializing in cost-effective OCI cloud migrations and programmatic motion graphics.' 
    },
    { 
      role: 'ICT Officer', 
      company: 'Crown Hospital', 
      date: '2025 - PRESENT', 
      desc: 'Leading the digital transformation of healthcare services, managing critical IT infrastructure, and ensuring seamless patient management systems.' 
    },
    { 
      role: 'Web Developer Instructor', 
      company: 'DISTech Africa', 
      date: '2024 - PRESENT', 
      desc: 'Curating technical curriculums and mentoring aspiring developers in modern full-stack technologies including React, Node.js, and database design.' 
    },
    { 
      role: 'Software Developer', 
      company: 'PhysioDigital Service', 
      date: '2024 - 2025', 
      desc: 'Developed high-performance cross-platform mobile applications using Flutter, focusing on real-time health monitoring and user engagement.' 
    },
    { 
      role: 'Software Developer', 
      company: 'Osmaxin Developers', 
      date: '2019 - 2020', 
      desc: 'Building enterprise-level applications and complex backend systems, driving technical decisions and architecture for long-term scalability.' 
    }
  ];

  const skillsData = [
    { 
      title: 'AI & Automation', 
      type: 'large',
      list: ['Deepgram AI', 'LiveKit (WebRTC)', 'Remotion', 'AI Orchestration'],
      icon: (
        <svg viewBox="0 0 24 24" className="skill-icon-bg"><path fill="currentColor" d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 12,2A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z" /></svg>
      )
    },
    { 
      title: 'Mobile Architecture', 
      type: 'wide',
      list: ['Flutter', 'Riverpod', 'GoRouter', 'State Management'],
      icon: (
        <svg viewBox="0 0 24 24" className="skill-icon-bg"><path fill="currentColor" d="M17,1H7A2,2 0 0,0 5,3V21A2,2 0 0,0 7,23H17A2,2 0 0,0 19,21V3A2,2 0 0,0 17,1M17,19H7V5H17V19Z" /></svg>
      )
    },
    { 
      title: 'Frontend Mastery', 
      type: 'wide',
      list: ['ReactJS', 'Next.js', 'TypeScript', 'TailwindCSS'],
      icon: (
        <svg viewBox="0 0 24 24" className="skill-icon-bg"><path fill="currentColor" d="M12,18.17L8.83,15L12,11.83L15.17,15L12,18.17M12,5.83L15.17,9L12,12.17L8.83,9L12,5.83M18,12L14.83,15.17L18,18.33L21.17,15.17L18,12M6,12L2.83,15.17L6,18.33L9.17,15.17L6,12Z" /></svg>
      )
    },
    { 
      title: 'Backend & Infrastructure', 
      type: 'wide',
      list: ['Go (Golang)', 'Fiber', 'Oracle Cloud (OCI)', 'Clean Architecture'],
      icon: (
        <svg viewBox="0 0 24 24" className="skill-icon-bg"><path fill="currentColor" d="M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z" /></svg>
      )
    },
    { 
      title: 'Cloud & DevOps', 
      type: 'wide',
      list: ['OCI Migration', 'Database Translation', 'CI/CD Pipelines', 'AWS'],
      icon: (
        <svg viewBox="0 0 24 24" className="skill-icon-bg"><path fill="currentColor" d="M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z" /></svg>
      )
    }
  ];

  return (
    <div className="about-page">
      {/* About Hero Section */}
      <section className="about-hero-section section">
        <div className="container">
          <div className="about-split">
            <div className="about-image-side">
              <div className="about-img-frame">
                <img src="/images/img.png" alt="Ikeh Victor" className="about-img" />
              </div>
            </div>
            <div className="about-text-side">
              <span className="section-tag">About Me</span>
              <h2 className="about-title">Driven by <span className="text-gradient">Innovation</span> & Design.</h2>
              <p className="about-p">
                I'm a **Versatile Full-Stack Engineer and AI Automation Specialist** currently driving technical innovation at **Prodcycle**. With over **7 years** of experience, I excel in building high-performance digital ecosystems using **Flutter**, **Next.js**, and **Go**.
              </p>
              <p className="about-p">
                Based in Anambra State, Nigeria, I specialize in architecting cost-effective, self-hosted cloud infrastructures on **OCI** and integrating cutting-edge AI services like **Deepgram** and **LiveKit** for real-time automation. My focus is on bridging the gap between complex backend engineering and premium user experiences.
              </p>
              <div className="about-stats-grid">
                <div className="about-stat">
                  <h4>7+</h4>
                  <span>Years Exp.</span>
                </div>
                <div className="about-stat">
                  <h4>20+</h4>
                  <span>Projects</span>
                </div>
              </div>
              <div className="about-cta" style={{marginTop: '3rem'}}>
                <Link to="/contact" className="btn btn-primary">Start a Conversation</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section section">
        <div className="container">
          <h2 className="section-title">Professional <span className="text-gradient">Timeline</span></h2>
          <div className="timeline-container">
            {timelineData.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-card">
                  <div className="timeline-header">
                    <span className="timeline-date">{item.date}</span>
                    <h3>{item.role}</h3>
                    <span className="timeline-company">{item.company}</span>
                  </div>
                  <p className="about-p" style={{fontSize: '1rem', marginBottom: 0}}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Skills Grid */}
      <section className="skills-grid-section section">
        <div className="container">
          <h2 className="section-title">Core <span className="text-gradient">Competencies</span></h2>
          <div className="skills-bento">
            {skillsData.map((skill, index) => (
              <div key={index} className={`skill-bento-card ${skill.type}`}>
                {skill.icon}
                <h3>{skill.title}</h3>
                <ul className="skill-list">
                  {skill.list.map(s => <li key={s} className="skill-tag">{s}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;